import {Box, Typography} from '@mui/material';
import {GetStaticProps} from 'next';
import {useTranslation} from 'next-i18next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {ImportantLink} from '../../components/common/button';
import {Page, PageSeo, PageType} from '../../components/common/container';
import {Title} from '../../components/common/text';
import Category from '../../components/help/Category';
import {useGetFaq} from '../../queries/helpQueries';
import {FaqCategory} from '../../types';
import {URL_SERVER_INTERNAL} from '../../utils/settings';

export default function FaqScreen(props: FaqStaticProps) {
    const {t} = useTranslation('common');
    const {data} = useGetFaq(props.data);

    if (!data) {
        return <></>;
    }

    return (
        <Page>
            <PageSeo page={PageType.FAQ} />
            <Title>{t('title.faq')}</Title>
            {data.map((c) => (
                <Category category={c} key={c.faq_category_id} />
            ))}
            <Box sx={{marginTop: '50px', textAlign: 'center'}}>
                <Typography>{t('tips.support')}</Typography>
            </Box>
            <Box
                sx={{
                    maxWidth: '200px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '25px',
                }}
            >
                <ImportantLink href={'/help/support'}>{t('action.support')}</ImportantLink>
            </Box>
        </Page>
    );
}

export type FaqStaticProps = {
    data: FaqCategory[];
};

export const getStaticProps: GetStaticProps<FaqStaticProps> = async (context) => {
    const translation = await serverSideTranslations(context.locale, ['common']);
    try {
        // console.log('context.locale = ', context.locale);

        let url = URL_SERVER_INTERNAL + '/faq';
        let requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const result = await fetch(url, requestOptions);
        const json = await result.json();

        return {
            props: {
                data: json,
                ...translation,
            },
            revalidate: 5,
        };
    } catch (e) {
        console.log('getServerSideProps::error faq', e);
        return {
            props: {
                data: null,
                ...translation,
            },
            revalidate: 5,
        };
    }
};
